import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DeliveryStatusTypesUi } from 'src/app/configs/delivery-status-ui.config';
import { LoggerService } from 'src/app/core/services/logger.service';
import { TranslationModule } from 'src/app/i18n';
import { PagesSharedModule } from 'src/app/pages/shared/pages-shared.module';
import { DoughnutChartModule } from 'src/app/shared/components/charts/doughnut-chart/doughnut-chart.module';
import { ModalTitleComponent } from 'src/app/shared/global/modal-title/modal-title.component';
import { ShareModule } from 'src/app/shared/share.module';
import { GetEnumValuesDto } from '../../../../core/api/models';
import { DeliveryStatus } from '../../../../core/api/models/delivery-status';
import { OutboxMessageNumbersService } from '../../../../core/api/services/outbox-message-numbers.service';
import { ApiNotificationService } from '../../../../core/services/api-notification.service';
import { PermissionService } from '../../../../core/services/authentication/permission.service';
import { DialogService } from '../../../../core/services/dialog.service';
import { DynamicTableService } from '../../../../core/services/dynamic-table.service';
import { TranslationService } from '../../../../i18n/translation.service';

@Component({
    selector: 'app-delivery-status-stats',
    templateUrl: './delivery-status-stats.component.html',
    styleUrls: ['./delivery-status-stats.component.scss'],
    imports: [
        CommonModule,
        ShareModule,
        TranslationModule,
        ReactiveFormsModule,
        FormsModule,
        PagesSharedModule,
        DoughnutChartModule,
        ModalTitleComponent,
    ]
})
export class DeliveryStatusStats implements OnInit {
  //#region Properties

  scheduledMessageId: number;

  deliveryStatusData: DeliveryStatusStatsDto[];

  DeliveryStatusEnumValues: GetEnumValuesDto[] = [];

  get DeliveryStatus() {
    return DeliveryStatus;
  }

  chartId = 'DeliveryStatusStatsPieChart';
  title = this.translate.instant('common.messageDeliveryStatusStats');
  labels: string[] = [];
  chartData: number[] = [];
  colors: string[] = [];

  //#endregion

  constructor(
    public translationService: TranslationService,
    public translate: TranslateService,
    protected currentService: OutboxMessageNumbersService,
    public dialogService: DialogService,
    public apiNotificationService: ApiNotificationService,
    public dynamicTableService: DynamicTableService,
    protected permissionService: PermissionService,
    private dialogRef: MatDialogRef<DeliveryStatusStats>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    protected elementRef: ElementRef,
    protected loggerService: LoggerService
  ) {
    if (data) {
      this.scheduledMessageId = data.scheduledMessageId;
      this.deliveryStatusData = data.deliveryStatusData;
      this.DeliveryStatusEnumValues = data.DeliveryStatusEnumValues;
      this.data.deliveryStatusData.forEach((item, i) => {
        let statusName = this.DeliveryStatusEnumValues.find(
          (a) => a.key == item.deliveryStatus
        )?.value;
        this.labels.push(statusName);
        this.chartData.push(item.count);
        this.colors.push(
          DeliveryStatusTypesUi.find((a) => a.type == item.deliveryStatus)
            ?.color
        );
      });
    }
  }

  ngOnInit() {}

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close(true);
  }
}

interface DeliveryStatusStatsDto {
  deliveryStatus: DeliveryStatus;
  count: number;
}
